import { sanitize } from '@Services/HtmlSanitizeService';
import { citationLiteratureFormatter } from '@Services/FormatUtils';
import { extractRefsFromSummary } from '@Containers/Summary/summaryRefsUtil';

function formatReferenceLine(citation, index) {
  if (!citation) return '';

  const title = citation.title ? sanitize(citation.title, 'discard', { allowedTags: [], allowedAttributes: {} }) : '';

  const authorNames = citation.authors?.map((auth) => auth?.author).filter(Boolean) || [];
  const authors =
    authorNames.length <= 9 ? authorNames.join('; ') : [...authorNames.slice(0, 7), '(...)', ...authorNames.slice(-2)].join('; ');

  const JOURNAL_FIELDS_MAPPER = [
    { field: 'issueTitle' },
    { field: 'issueYear' },
    { field: 'issueVolume' },
    { field: 'issueNo' },
    { field: 'articleNo' },
    { field: 'issuePages' },
  ];

  const journalsLine = citation.citationJournals
    ? // eslint-disable-next-line custom/no-unsafe-deep-access
      citation.citationJournals
        .map((journal) => {
          const parts = JOURNAL_FIELDS_MAPPER.reduce((acc, { field }) => {
            const value = journal?.[field];
            if (!value) return acc;
            acc.push(value);
            return acc;
          }, []);
          const html = parts.join(', ');
          return html ? sanitize(html, 'discard', { allowedTags: [], allowedAttributes: {} }) : '';
        })
        .filter(Boolean)
        .join('; ')
    : '';

  const assigneesLine = citation.assignees
    ? `Current patent assignee: ${sanitize(String(citation.assignees), 'discard', { allowedTags: [], allowedAttributes: {} })}`
    : '';

  const patentsLine = citation.citationPatents
    ? sanitize(citationLiteratureFormatter(citation.citationPatents), 'discard', { allowedTags: [], allowedAttributes: {} })
    : '';

  // eslint-disable-next-line custom/no-unsafe-deep-access
  return [`${index}. ${title}`, journalsLine, patentsLine, assigneesLine, authors].filter(Boolean).join('\n');
}

export default function formatReferencesCopyToClipboard(summary, referencedCitations) {
  if (!Array.isArray(referencedCitations) || !referencedCitations.length) {
    return '';
  }

  // Map {[cnr]: index}
  const refsFromSummary = extractRefsFromSummary(summary, referencedCitations);

  // eslint-disable-next-line custom/no-unsafe-deep-access
  const formattedReferences = referencedCitations
    .filter((cit) => cit && refsFromSummary[cit.id])
    .map((cit) => formatReferenceLine(cit, refsFromSummary[cit.id]))
    .join('\n\n');

  return `\n\n---\n\n## References\n\n${formattedReferences}\n`;
}
